import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var Cancel = function (props) {
  return React__default.createElement("svg", __assign({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M2.35352 1.64648L1.64648 2.35352L5.29297 6L1.64648 9.64648L2.35352 10.3535L6 6.70703L9.64648 10.3535L10.3535 9.64648L6.70703 6L10.3535 2.35352L9.64648 1.64648L6 5.29297L2.35352 1.64648Z",
    fill: "currentColor"
  }));
};
export { Cancel as default };
//# sourceMappingURL=Cancel.js.map
